import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import { throttle } from 'underscore';

Snappy.Component.SubNavigation = class SubNavigation extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-sub-navigation';
	}

	constructor(element) {
		super(element);

		this.adjustmentCount = 0;
	}

	render() {
		this.setVars();
		this.addListeners();

		if (window.matchMedia('(min-width: 992px)').matches) {
			this.calculateMenuItemsPosition();
		}
	}

	setVars() {
		this.$mainMenu = this.$element.find('.fa-sub-navigation__section-links');
		this.$mainMenuItems = this.$mainMenu.find('.section-links__list');
		this.$innerContent = this.$element.find('.fa-sub-navigation__inner-content');
		this.$moreMenu = this.$element.find('.section-links__more-dropdown');
		this.$moreBtn = this.$element.find('.section-links__more-text');
		this.$moreBtnParent = this.$element.find('.section-links__more-list-item');
	}

	addListeners() {
		const throttledViewportResizeHandler = throttle(this.onViewportResize.bind(this), 100);
		const throttledOnScrollHandler = throttle(this.onDocumentScroll.bind(this), 50);

		this.$window.on('resize', throttledViewportResizeHandler);
		this.$window.on('scroll', throttledOnScrollHandler);
		this.$moreBtn.on('mouseover focus', this.onMoreBtnHover.bind(this));
		this.$moreBtn.on('mouseout focusout', this.onMoreBtnBlur.bind(this));
		this.$moreMenu.on('mouseout focusout', this.onMoreBtnBlur.bind(this));
	}

	onViewportResize() {
		if (window.matchMedia('(min-width: 992px)').matches) {
			this.calculateMenuItemsPosition();
		}
	}

	onDocumentScroll() {
		this.stickySubNavIsActive = this.$window.scrollTop() > 40;

		this.toggleStickySubNav();
	}

	onMoreBtnHover() {
		this.$moreBtnParent.addClass('active');
	}

	onMoreBtnBlur(event) {
		const toElement = event.toElement || event.relatedTarget;
		const toElementIsInContainingElementChildren = $.contains(this.$moreMenu[0], toElement);

		if (!toElementIsInContainingElementChildren) {
			this.$moreBtnParent.removeClass('active');
		}
	}

	calculateMenuItemsPosition() {
		// need to show/hide ul if has content/empty
		this.mainMenuWidth = this.$mainMenu.width();
		this.availableSpace = this.$innerContent.width() - 160;
		this.viewportIsTooNarrow = this.mainMenuWidth > this.availableSpace;

		this.toggleMoreButtonVisibility();

		if (this.viewportIsTooNarrow) {
			this.moveListItemToMoreDropdown();
		} else {
			if (this.cachedMainMenu < this.availableSpace) {
				const $listItem = this.$moreMenu.find('.section-links__list-item').last();

				$listItem.insertBefore(this.$mainMenuItems.find('.section-links__more-list-item'));
				this.calculateMenuItemsPosition();
			}
		}
	}

	toggleMoreButtonVisibility() {
		this.$element.toggleClass('fa-sub-navigation--viewport-narrow', this.viewportIsTooNarrow || this.adjustmentCount > 0);
	}

	moveListItemToMoreDropdown() {
		let $listItem = this.$mainMenu.find('.section-links__list > .section-links__list-item:not(.section-links__more-list-item)').last();
		const $clonedListItem = $listItem.clone();

		this.$moreMenu.append($clonedListItem[0]);
		$listItem.remove();
		this.adjustmentCount += 1;
		this.cachedMainMenu = this.mainMenuWidth;

		this.calculateMenuItemsPosition();
	}

	toggleStickySubNav() {
		this.$body.toggleClass('sticky-subnav--active', this.stickySubNavIsActive);
	}
};



// WEBPACK FOOTER //
// ./components/subNavigation/scripts/subNavigation.js